import { BaseService } from '@/infra/services/base-service';
import { Company } from '@/types/Company';
import { GetCompaniesMapper } from '@/core/mappers/company';
import { GetCompanyListRequestDTO, GetCompanyListResponseDTO } from '@/core/dto/company';

export class CompanyService extends BaseService {
	private static instance: CompanyService;

	private constructor(public readonly basePath: string = '/company') {
		super();
	}

	public static getInstance(): CompanyService {
		if (!CompanyService.instance) {
			CompanyService.instance = new CompanyService();
		}
		return CompanyService.instance;
	}

	public async index(params: GetCompanyListRequestDTO): Promise<Company[]> {
		const url = this.basePath + `/user_list/${params.organization_id}`;
		const { data } = await this.getInstance().get<GetCompanyListResponseDTO>(url);
		return new GetCompaniesMapper(data).toDomain();
	}
}
